<mat-spinner [attr.aria-label]="'Loader for ' + componentName" mode="indeterminate"></mat-spinner>
<span [class.white]="isWhiteText">Loading...</span>
